import { IMAGES } from "../data/site";

/* eslint-disable react/no-unescaped-entities */

const PROJECTS = [
  { title: "Stamped Patio", area: "Tarrytown", img: IMAGES.stamped, span: "md:col-span-6 md:row-span-2" },
  { title: "Modern Driveway", area: "Mueller", img: IMAGES.driveway, span: "md:col-span-3" },
  { title: "Xeriscape Yard", area: "South Austin", img: IMAGES.xeriscape1, span: "md:col-span-3" },
  { title: "Outdoor Fire Pit", area: "Lakeway", img: IMAGES.firepit, span: "md:col-span-3" },
  { title: "Pool Deck", area: "Westlake", img: IMAGES.pool, span: "md:col-span-3" },
  { title: "Foundation Pour", area: "Round Rock", img: IMAGES.concreteWorker, span: "md:col-span-6" },
];

export default function Portfolio() {
  return (
    <section data-testid="portfolio-section" className="bg-stone-50 py-20 md:py-28 border-y border-stone-200">
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-12">
          <div>
            <div className="text-xs uppercase tracking-[0.22em] font-bold text-red-600">
              Recent work
            </div>
            <h2 className="mt-3 font-display text-4xl sm:text-5xl font-black tracking-tighter text-stone-900 leading-[1.02]">
              Built across Austin.
            </h2>
          </div>
          <p className="max-w-md text-stone-600">
            A few of the patios, driveways, foundations and xeriscape conversions we've
            completed across Austin and the Hill Country.
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-12 md:grid-rows-2 gap-3 md:gap-4">
          {PROJECTS.map((p) => (
            <figure
              key={p.title}
              className={`relative overflow-hidden border border-stone-200 group min-h-[160px] md:min-h-[260px] ${p.span}`}
              data-testid={`project-${p.title.toLowerCase().replace(/\s/g, "-")}`}
            >
              <img
                src={p.img}
                alt={`${p.title} in ${p.area}, Austin TX`}
                className="absolute inset-0 w-full h-full object-cover group-hover:scale-[1.04] transition-transform duration-700"
                loading="lazy"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-stone-950/85 via-stone-950/10 to-transparent" />
              <figcaption className="absolute bottom-0 left-0 right-0 p-5 text-white">
                <div className="text-[10px] uppercase tracking-[0.22em] text-red-400 font-bold">
                  {p.area}
                </div>
                <div className="font-display text-lg md:text-xl font-bold tracking-tight">
                  {p.title}
                </div>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}
